import { render, staticRenderFns } from "./OrderError.vue?vue&type=template&id=7f0a0d1c&scoped=true"
import script from "./OrderError.vue?vue&type=script&lang=js"
export * from "./OrderError.vue?vue&type=script&lang=js"
import style0 from "./OrderError.vue?vue&type=style&index=0&id=7f0a0d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a0d1c",
  null
  
)

export default component.exports